import React from "react";
import { motion } from "framer-motion";
import {
  SiSpotify, SiApplemusic, SiYoutubemusic, SiYoutube, SiTiktok,
  SiTidal, SiShazam, SiSoundcloud,
} from "react-icons/si";

const ITEMS = [
  { Icon: SiSpotify, name: "Spotify", color: "#1DB954", text: "#000000" },
  { Icon: SiApplemusic, name: "Apple Music", color: "#FA243C", text: "#ffffff" },
  { Icon: SiYoutubemusic, name: "YouTube Music", color: "#FF0000", text: "#ffffff" },
  { Icon: SiYoutube, name: "YouTube", color: "#FF0000", text: "#ffffff" },
  { Icon: SiTiktok, name: "TikTok", color: "#000000", text: "#00f2ea" },
  { Icon: SiTidal, name: "Tidal", color: "#000000", text: "#00FFFF" },
  { Icon: SiShazam, name: "Shazam", color: "#0088FF", text: "#ffffff" },
  { Icon: SiSoundcloud, name: "SoundCloud", color: "#FF5500", text: "#ffffff" },
];

export default function Platforms() {
  return (
    <section id="platforms" className="py-20 md:py-28 relative">
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <div className="text-center max-w-3xl mx-auto">
          <h2 className="text-3xl md:text-4xl font-bold tracking-tight">
            موزیک شما در <span className="gradient-text-neon">پلتفرم‌های جهانی</span> منتشر می‌شود
          </h2>
          <p className="mt-4 text-slate-300 leading-relaxed">
            آثار شما را در سرویس‌های معتبر موسیقی و ویدیو در سطح بین‌المللی منتشر می‌کنیم
            تا مخاطبان شما بتوانند از سراسر دنیا به موزیکتان دسترسی داشته باشند.
          </p>
        </div>

        <div className="mt-12 grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 gap-4">
          {ITEMS.map(({ Icon, name, color, text }, i) => (
            <motion.div
              key={i}
              initial={{ opacity: 0, y: 10 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, amount: 0.1 }}
              transition={{ duration: 0.35, delay: i * 0.04 }}
              className="platform-card group glass rounded-2xl px-4 py-6 flex flex-col items-center justify-center gap-3 transition-all duration-500 ease-out cursor-default border border-white/10"
              style={{ "--hover-bg": color, "--hover-text": text }}
              data-testid={`platform-${name.toLowerCase().replace(/\s/g, "-")}`}
            >
              <Icon className="w-8 h-8 text-slate-100 transition-colors duration-500 group-hover:[color:var(--hover-text)]" />
              <span className="text-xs sm:text-sm font-medium text-slate-200 text-center transition-colors duration-500 group-hover:[color:var(--hover-text)]">
                {name}
              </span>
            </motion.div>
          ))}
        </div>

        <p className="mt-8 text-center text-sm text-slate-400">و بیش از ۷۰ پلتفرم شناخته شده بین‌المللی دیگر</p>
      </div>
    </section>
  );
}
